/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {
    TestEmailApiParameter,
    validateQuoteEmailApi,
} from "@eisinc/App/Services/TestRegistrationEmailValidityService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface CheckRegistrationEmailParameter {
    email: string;
    onSuccess?: (error: string) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    CheckRegistrationEmailParameter,
    TestEmailApiParameter,
    ServiceResult<any>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const checkIfEmailIsvalid: HandlerType = async props => {
    props.apiResult = await validateQuoteEmailApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const chain = [PopulateApiParameter, checkIfEmailIsvalid, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const checkQuoteEmail = createHandlerChainRunner(chain, "checkQuoteEmail");
export default checkQuoteEmail;
